import BaseModel from 'models/base-model';

export default class EditPermission extends BaseModel({
  editPermissionAutotieout: true,
}) {
  setEditPermissionAutotieout(payload) {
    return this.merge({
      editPermissionAutotieout: payload,
    });
  }
}
